<template>
  <div>
    <Modal v-model="paymentVoucherModal" :title="paymentVoucherTitle" class-name="paymentVoucherStyles"
      :transfer="false" :mask-closable="false" width="800" @on-visible-change="paymentVoucherChange">
      <Form ref="paymentVoucherForm" :model="paymentVoucherForm" :label-width="120" :rules="ruleValidate" @submit.native.prevent>
        <Row style="width: 90%;">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001491')" prop="channel">
              <span v-if="paymentVoucherType === 'look'">{{ paymentVoucherForm.channel }}</span>
              <Select v-else v-model="paymentVoucherForm.channel" filterable transfer style="width:300px;" @on-change="changeChannel">
                <Option v-for="(item, index) in paymentChannelsList" :value="item.channel" :key="index">{{ item.channel }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="paymentVoucherForm.channel">
            <FormItem :label="$t('key1001492')" prop="account">
              <span v-if="paymentVoucherType === 'look'">{{ paymentVoucherForm.account }}</span>
              <div v-else class="flex align-items-center">
                <Select v-model="paymentVoucherForm.account" filterable transfer style="width:300px;" @on-change="changeAccount">
                  <Option v-for="(item, index) in accountList" :value="item.account" :key="index">{{ item.account }}</Option>
                </Select>
                <span class="ml20" :class="paymentVoucherForm.account ? 'themeColor cursor' : ''" @click="viewCompleteMessage">{{ $t('key1001503') }}</span>
              </div>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="paymentVoucherForm.account">
            <FormItem :label="$t('key1001493')" prop="receiveTotalPrice">
              <p v-if="paymentVoucherType === 'look'" class="flex align-items-center">
                <span class="mr60">{{ totalPayableAmount }}</span>
                <span> {{ $t('key1001496') + paymentVoucherForm.receiveTotalPrice + ' ' + paymentVoucherForm.currency }}</span>
              </p>
              <div v-else class="flex-direction">
                <Input disabled v-model.trim="totalPayableAmount" style="width:300px;"></Input>
                <p class="width_300 text-align-right font-size-12" v-if="paymentVoucherForm.channel && paymentVoucherForm.account">
                  {{ $t('key1001496') + paymentVoucherForm.receiveTotalPrice + ' ' + paymentVoucherForm.currency }}
                </p>
              </div>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001494')" prop="buyerName" class="required_style_label">
              <div class="flex align-items-center">
                <template v-if="paymentVoucherForm.imagePaths.length >0">
                  <div class="img_style" v-for="(url, index) in paymentVoucherForm.imagePaths" v-viewer="viewerOptions">
                    <img :src="setImgPath(url)" alt="" :class="paymentVoucherType === 'look'? 'cursor' : ''"/>
                    <Icon type="ios-close-circle" v-if="paymentVoucherType !== 'look'" class="del-icon" @click.stop="delProductImages(index)"/>
                  </div>
                </template>
                <Upload
                  v-if="paymentVoucherForm.imagePaths.length < 5 && paymentVoucherType !== 'look'"
                  class="upload_styles"
                  ref="upload"
                  type="drag"
                  name="files"
                  multiple
                  :headers="headObj"
                  :action="fileApi"
                  :data="uploadData"
                  :show-upload-list="false"
                  :on-success="uploadSuccess"
                  :format="['jpg', 'jpeg', 'png']"
                  :max-size="5120"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize">
                  <div class="upload_icon_box">
                    <Icon type="ios-cloud-upload" size="45" style="color: #3399ff"></Icon>
                    <p>{{ $t('key1000465') }}</p>
                  </div>
                </Upload>
              </div>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001495')" prop="remark">
              <span v-if="paymentVoucherType === 'look'">{{ paymentVoucherForm.remark }}</span>
              <Input v-else type="textarea" :showWordLimit="true" :maxlength="200"
                :autosize="{ minRows: 4, maxRows: 6}" v-model.trim="paymentVoucherForm.remark">
              </Input>
            </Form-item>
          </Col>
          <p class="ml54">
            {{ $t('key1000615') }}<br/>
            {{ $t('key1001504') }}
          </p>
        </Row>
      </Form>
      <template #footer>
        <Button type="primary" @click="paymentVoucherModal = false" v-if="paymentVoucherType === 'look'">{{ $t('key1000732') }}</Button>
        <template v-else>
          <Button @click="paymentVoucherModal = false">{{ $t('key1000112') }}</Button>
          <Button type="primary" @click="paymentVoucherBtn" :loading="paymentVoucherLoading">{{ $t('key1000367') }}</Button>
        </template>
      </template>
    </Modal>
    <!--账户完整信息弹窗-->
    <completeAccountInfoModal ref="completeAccountInfo"></completeAccountInfoModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {amountHandel, getCurrencyConversion, getPaymentChannelsData} from "@/utils/common";
import completeAccountInfoModal from "@/views/distributor/components/orderManage/completeAccountInfoModal.vue";

export default {
  name: 'paymentVoucherModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      paymentVoucherModal: false,
      paymentVoucherTitle: '',
      paymentVoucherType: null,
      paymentVoucherForm: {
        channel: null,
        account: null,
        receiveTotalPrice: null,
        currency: null,
        imagePaths: [],
        remark: ''
      },
      ruleValidate: {
        channel: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001479'), trigger: 'change'}
        ],
        account: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001480'), trigger: 'change'}
        ]
      },
      paymentChannelsList: [],
      accountList: [],
      paymentVoucherLoading: false,
      fileApi: api.erpCommon_uploadFiles + '?basePath=yms-distributor-service&action="uploadimage"',
      uploadData: {},
      totalPayableAmount: null,
      detailsData: null,
    };
  },
  methods: {
    // 初始化数据
    initPaymentVoucherData(type, row) {
      this.accountList = [];
      this.detailsData = row;
      let {totalOrderAmount, totalOrderAmountCurrency, ymsPackagePayId} = row;
      this.totalPayableAmount = totalOrderAmount + ' ' + totalOrderAmountCurrency;
      this.ymsPackagePayId = ymsPackagePayId;
      (async () => {
        await getPaymentChannelsData('?status=1').then((data) => {
          this.paymentChannelsList = data;
        });
        await handleData();
      })();
      const handleData = () => {
        return new Promise((resolve) => {
          let obj = {
            add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000614'),
            edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006293'),
            look: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006294'),
            update: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006295')
          };
          this.paymentVoucherTitle = obj[type];
          this.paymentVoucherType = type;
          if (type !== 'add') {
            this.getPaymentDetails(ymsPackagePayId);
          } else {
            this.paymentVoucherModal = true;
          }
        });
      };
    },
    // 获取付款详情
    getPaymentDetails(ymsPackagePayId) {
      this.axios.get(api.get_ymsPackagePay + ymsPackagePayId).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          let accountList = [];
          if (data) {
            this.$refs['paymentVoucherForm'].resetFields();
            let {account, channel, remark} = data;
            this.paymentVoucherForm.account = account;
            this.paymentVoucherForm.channel = channel;
            let channelTalg = this.paymentChannelsList.some(item => item.channel === channel);
            let accountTalg = this.paymentChannelsList.some(item => item.account === account);
            if (!channelTalg) {
              this.paymentChannelsList.unshift({
                ...data,
                status: 0
              });
            }
            if (!accountTalg) {
              accountList.unshift({
                ...data,
                status: 0
              });
            }
            this.paymentVoucherForm.remark = remark;
            this.changeChannel(channel, account, accountList, true);
            let ymsPackagePayVouchers = data.ymsPackagePayVouchers || [];
            this.paymentVoucherForm.imagePaths = ymsPackagePayVouchers.map((item) => {
              if (item.imagePath) {
                return item.imagePath;
              }
            });
            this.paymentVoucherModal = true;
          }
        }
      });
    },
    // 提交
    paymentVoucherBtn() {
      let v = this;
      let channelTalg = false;
      let accountTalg = false;
      v.paymentChannelsList.map((item) => {
        if (item.channel === v.paymentVoucherForm.channel) {
          channelTalg = item.status === 1;
        }
      });
      v.accountList.map((item) => {
        if (item.account === v.paymentVoucherForm.account) {
          accountTalg = item.status === 1;
        }
      });
      if (channelTalg && accountTalg) {
        let url = '';
        let method = '';
        let text = '';
        let query = Object.assign({}, v.paymentVoucherForm);
        if (v.paymentVoucherType === 'add') {
          url = api.post_ymsPackagePay_uploadPayVoucher;
          method = 'post';
          text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000251');
        } else {
          url = api.put_ymsPackagePay_updatePayVoucher;
          method = 'put';
          text = v.paymentVoucherType === 'edit' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161');
        }
        if (v.paymentVoucherForm.imagePaths.length <= 0) {
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006296'));
          return false;
        }
        query.ymsPackagePayId = v.ymsPackagePayId;
        v.$refs['paymentVoucherForm'].validate((valid) => {
          if (valid) {
            let list = v.accountList.filter((item) => item.account === v.paymentVoucherForm.account);
            query.accountRemark = list[0].remark;
            v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.paymentVoucherModal = false;
                v.$Message.success(text);
                v.$emit('updateData', true);
              }
            });
          }
        });
      } else {
        v.$Modal.warning({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000330'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006292'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000316'),
        });
      }
    },
    // 上传支付流水图片
    uploadSuccess(response, file, fileList) {
      let v = this;
      if (response.code === 0) {
        v.paymentVoucherForm.imagePaths = [
          ...v.paymentVoucherForm.imagePaths,
          response.datas[0]
        ].slice(0, 5);
        v.$Message.success(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000251')}`);
      } else {
        v.$Message.error(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000457')}`);
      }
    },
    // 校验文件格式
    handleFormatError(file) {
      let v = this;
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001477')}`,
        duration: 4
      });
    },
    // 限制上传的文件不能超过5M
    handleMaxSize(file) {
      let v = this;
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001478')}`,
        duration: 4
      });
    },
    // 删除图片
    delProductImages(index) {
      this.paymentVoucherForm.imagePaths.splice(index, 1);
      this.$forceUpdate();
    },
    // 选择支付渠道
    changeChannel(value, account, newData = [], val) {
      this.accountList = [];
      if (value) {
        let newList = this.paymentChannelsList.filter((item) => item.channel === value);
        let data = [...newData, ...newList];
        this.accountList = this.uniqueFunc(data, 'account');
        if (!val) {
          this.paymentVoucherForm.account = null;
          if (this.accountList.length > 0) {
            this.paymentVoucherForm.account = this.accountList[0].account;
            this.changeAccount(this.paymentVoucherForm.account);
          }
        } else {
          this.changeAccount(account);
        }
      }
    },
    // 选择账户
    changeAccount(value) {
      let {totalOrderAmount, totalOrderAmountCurrency} = this.detailsData;
      let list = this.accountList.filter((item) => item.account === value);
      if (list.length > 0) {
        let query = {
          price: totalOrderAmount,
          priceCurrency: totalOrderAmountCurrency,
          targetCurrency: list[0].currency
        };
        getCurrencyConversion(query).then((item) => {
          this.paymentVoucherForm.receiveTotalPrice = amountHandel(item.targetPrice);
          this.paymentVoucherForm.currency = item.targetCurrency;
        });
      }
    },
    // 查看完整消息
    viewCompleteMessage() {
      let list = this.accountList.filter((item) => item.account === this.paymentVoucherForm.account);
      this.$refs['completeAccountInfo'].initCompleteAccountInfoData(list[0]);
    },
    // 监听弹窗
    paymentVoucherChange(value) {
      if (!value) {
        this.paymentChannelsList = [];
        this.accountList = [];
        this.totalPayableAmount = null;
        this.$refs['paymentVoucherForm'].resetFields();
        this.paymentVoucherForm.imagePaths = [];
        this.paymentVoucherForm.receiveTotalPrice = null;
        this.paymentVoucherForm.currency = null;
        this.ymsPackagePayId = null;
        this.detailsData = null;
      }
    },
  },
  components: {
    completeAccountInfoModal
  }
};
</script>

<style lang="less" scoped>
/deep/ .paymentVoucherStyles {
  .upload_styles {
    .ivu-upload.ivu-upload-drag {
      width: 100px;
      height: 100px;
    }

    .upload_icon_box {
      width: 100px;
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
    }
  }

  .img_style {
    width: 100px;
    height: 100px;
    margin-right: 12px;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      display: inline-block;
      object-fit: cover;
      vertical-align: middle;
      border: 1px solid #ddd;
      border-radius: 5px;
    }

    &:hover .del-icon {
      display: block;
      z-index: 1000;
    }
  }

  .del-icon {
    font-size: 24px;
    position: absolute;
    top: -10px;
    right: -10px;
    cursor: pointer;
    display: none;

    &:hover {
      color: #ff0000;
    }
  }
}
</style>
